// View Size
export const DEFAULT_VIEW_SIZE = 48;
export const MAX_DEFAULT_VIEW_SIZE = 144;

// Grid Highlights
export const FILTERS_HIGHLIGHT = "Filters_Highlight";
export const MIN_HIGHLIGHTS_LENGTH = 3;

// Videos positions
export const VIDEO_POSITIONS_IN_GRID = [5, 20, 37];

// Hero products positions
export const HERO_POSITIONS_IN_GRID = [5, 12, 21, 28, 37, 44];

// Edito position limit
export const MAX_EDITO_NUMBER_PER_GRID = 2;
export const SECOND_EDITO_LIMIT_DESKTOP = 36;
export const SECOND_EDITO_LIMIT_MOBILE = 18;
export const SECOND_EDITO_LIMIT_MOBILE_LIST = 9;

// Filters & Facets
export const DEFAULT_FILTER_BAR_HEIGHT = 75;
export const FILTER_DESKTOP_FIXED_UNDER_HEADER =
    "filter-desktop-fixed-under-header";
export const FILTER_DESKTOP_FIXED_TOP = "filter-desktop-fixed-top";
export const FILTER_DESKTOP_EMPTY = "empty";
export const MAX_CHUNK_SIZE = 15;
export const MAX_COMBINED_FACET = 2;

// Analytics
export const ECOMMERCE = "ecommerce";
export const FILTERS = "Filters";
export const OPEN_FILTER = "openFilter";
export const CLOSE_FILTER = "closeFilter";
export const PRODUCT_CLICK = "productClick";
export const PRODUCT_GRID = "product grid";
export const EVENT_PRODUCT_GRID = "Product_Grid";
export const EVENT_SEARCH_ERROR_CATEGORY = "error message";
export const FACET_GRID = "product grid - facet";
export const FACET_COMBINED_GRID = "product grid - facet combined";
export const FACET_GRID_REDIRECTED = "product grid - redirected";
export const SEARCH_GRID = "product grid - search";
export const CLEAR = "Clear";
export const SORTBY = "SortBy";
export const LOAD_MORE = "LoadMore";

export const CATEGORIES = "categories";
export const GRID_SORT_BUTTON_ID = "button-sort-by";

export const SEARCH = "Search";
export const REFACTORED_RESULTS = "Refactored Results";
export const ZERO_RESULTS = "Zero Results";
export const WITH_RESULTS = "With Results";
